import { ReplyOutlined } from '@mui/icons-material';
import React, { useState } from 'react';
import { PostCommentInput } from '../../PostCommentInput/PostCommentInput';
import styles from '../CommentItem.module.scss';

interface CommentActionsProps {
  postId: string;
  commentId?: string;
  isDeleted: boolean;
  isHasParent?: boolean;
  onCommentPosted: (newComment: any) => void;
}

export const CommentActions: React.FC<CommentActionsProps> = ({
  postId,
  commentId,
  isDeleted,
  isHasParent,
  onCommentPosted,
}) => {
  const isReply = true;
  const [isReplying, setIsReplying] = useState(false);
  const handleReplyClick = () => setIsReplying((prev) => !prev);
  const handleCommentPosted = (newComment: any) => {
    handleReplyClick();
    onCommentPosted(newComment);
  };

  return (
    <div className={styles.commentMeta}>
      {!isHasParent && !isDeleted && (
        <div className={styles.actions}>
          <div className={styles.replyButton} onClick={handleReplyClick}>
            <ReplyOutlined sx={{ fill: 'transparent', stroke: 'black' }} />
            Reply
          </div>
        </div>
      )}

      {isReplying && (
        <div className={styles.replyInput}>
          <PostCommentInput
            postId={postId}
            commentId={commentId}
            isReply={isReply}
            onCommentPosted={handleCommentPosted}
          />
        </div>
      )}
    </div>
  );
};
